import { PDFDocument, StandardFonts, rgb } from "pdf-lib";

const participantNameBaselines = [629, 629, 629, 617, 629, 629, 617, 617, 629, 629];
const navy = rgb(0.047, 0.18, 0.325);

function fitText(font, text, maxWidth, initialSize = 8, minimumSize = 5.8) {
  let size = initialSize;
  while (size > minimumSize && font.widthOfTextAtSize(text, size) > maxWidth) size -= 0.25;
  return size;
}

function dataUrlBytes(dataUrl) {
  const encoded = dataUrl.slice(dataUrl.indexOf(",") + 1);
  const binary = window.atob(encoded);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
}

function drawFittedImage(page, image, bounds) {
  const scale = Math.min(bounds.width / image.width, bounds.height / image.height);
  const width = image.width * scale;
  const height = image.height * scale;
  page.drawImage(image, {
    x: bounds.x + (bounds.width - width) / 2,
    y: bounds.y + (bounds.height - height) / 2,
    width,
    height,
  });
}

export async function buildContractPreviewPdf(sourceBytes, input) {
  const document = await PDFDocument.load(sourceBytes.slice());
  const regular = await document.embedFont(StandardFonts.Helvetica);
  const participantName = input.participantName.trim();
  const guardianName = input.guardianName.trim();
  const participantSignature = input.participantSignature
    ? await document.embedPng(dataUrlBytes(input.participantSignature))
    : null;
  const guardianSignature = input.isMinor && input.guardianSignature
    ? await document.embedPng(dataUrlBytes(input.guardianSignature))
    : null;

  for (const [pageIndex, page] of document.getPages().entries()) {
    const participantNameBaseline = participantNameBaselines[pageIndex] || 629;

    if (participantName) {
      page.drawRectangle({
        x: 211,
        y: participantNameBaseline - 3,
        width: 336,
        height: 12,
        color: rgb(0.94, 0.965, 0.978),
      });
      page.drawText(participantName, {
        x: 214,
        y: participantNameBaseline,
        size: fitText(regular, participantName, 330, 9.3, 6.4),
        font: regular,
        color: navy,
      });
      page.drawText(participantName, {
        x: 284,
        y: 44.8,
        size: fitText(regular, participantName, 74, 7.2),
        font: regular,
        color: navy,
      });
    }

    if (participantSignature) {
      drawFittedImage(page, participantSignature, { x: 233, y: 59, width: 146, height: 31 });
    }
    if (participantName || participantSignature) {
      page.drawText(input.signingDate, { x: 280, y: 34.7, size: 7.1, font: regular, color: navy });
    }

    if (input.isMinor) {
      if (guardianSignature) {
        drawFittedImage(page, guardianSignature, { x: 396, y: 59, width: 146, height: 31 });
      }
      if (guardianName) {
        page.drawText(guardianName, {
          x: 449,
          y: 44.8,
          size: fitText(regular, guardianName, 77, 7.2),
          font: regular,
          color: navy,
        });
      }
      if (guardianName || guardianSignature) {
        page.drawText(input.signingDate, { x: 446, y: 34.7, size: 7.1, font: regular, color: navy });
      }
    }
  }

  return document.save({ useObjectStreams: false });
}
